<template>

  <rpm-table
    title="Categorias das organizações"
    :columns="columns"
    :data="organizationCategories"
    :tableDataIsLoading="tableDataIsLoading"
    @change-page="getOrganizationCategories"
  >
    <template #functions>
      <section class="flex flex-row-reverse w-full">
        <rpm-button
          class="w-6 h-6 rounded"
          font-size="text-sm"
          icon="fa-solid fa-plus"
          @click="openModal({})"
        ></rpm-button>
      </section>
    </template>

    <template #actions="{ item }">
      <rpm-button
        icon="fa-solid fa-pen-to-square"
        color="transparent"
        tooltip-text="editar"
        @click="openModal(item)"
      ></rpm-button>
    </template>
  </rpm-table>

  <rpm-modal
    :header="this.organizationCategoryForm.id ? 'Atualizar Categoria de Organização':'Criar Categoria de Organização'"
    class="flex flex-col gap-y-8"
    persist
    :open="modalOpen"
    @close="modalOpen = false"
  >

    <section class="flex flex-col gap-6">

      <rpm-input
        v-model="organizationCategoryForm.name"
        :errors="errors.name"
        label="Nome"
        required
        placeholder="Nome"
      ></rpm-input>

      <rpm-input
        v-model="organizationCategoryForm.hierarchy"
        :errors="errors.hierarchy"
        type="text"
        label="Hierarquia"
        required
        placeholder="Hierarquia"
      ></rpm-input>

    </section>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
        color="gray"
        label="Cancelar"
        @click="modalOpen = false"
      ></rpm-button>

      <rpm-button
        label="Confirmar"
        @click="save"
      ></rpm-button>
    </section>

  </rpm-modal>

</template>


<script>

import RpmTable from "#components/RpmTable.vue";
import RpmModal from "#components/RpmModal.vue";
import Badge from "#components/Badge.vue";
import organizationCategoryRepository from "#repositories/organizationCategoryRepository";
import {getErrors} from "#functions/validator";

export default {
  name: "OrganizationCategories",
  components: {
    RpmTable,
    RpmModal,
    Badge
  },
  data() {
    return {
      errors: {},
      columns: [
        {
          field: "name",
          label: "Nome",
        },
        {
          field: "hierarchy",
          label: "Hierarquia",
        },
      ],
      tableDataIsLoading: true,
      organizationCategories: [],
      organizationCategoryForm: {},
      modalOpen: false,
      loading: false,
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      }
    };
  },
  methods: {
    async getOrganizationCategories() {
      this.tableDataIsLoading = true;

      this.organizationCategories = (await organizationCategoryRepository.getOrganizationCategories()).data;

      this.tableDataIsLoading = false;
    },
    openModal(item) {
      this.modalOpen = true;
      this.organizationCategoryForm = item;
    },
    async save() {
      this.loading = true;
      if(this.organizationCategoryForm.id){
        organizationCategoryRepository.updateOrganizationCategory(this.organizationCategoryForm.id, this.organizationCategoryForm).then(() => {
          this.$notify('Categoria de organização modificada', 'success');
          this.getOrganizationCategories();
          this.modalOpen = false;
        }).catch((response) => {
          this.$notify('Erro ao modificar categoria de organização', 'error');
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.loading = false;
        });
      }else{
        organizationCategoryRepository.storeOrganizationCategory(this.organizationCategoryForm).then(() => {
          this.$notify('Categoria de organização criada', 'success');
          this.getOrganizationCategories();
          this.modalOpen = false;
        }).catch((response) => {
          this.$notify('Erro ao criar categoria de organização', 'error');
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    this.getOrganizationCategories();
  },
};
</script>

